<!--
 * @Descripttion:
 * @version: 1.1.1
 * @Author: xiaoan
 * @Date: 2022-06-28 22:55:30
 * @LastEditors: xiaoan
 * @LastEditTime: 2023-03-08 22:59:20
-->
<template>
  <div class="page">
    <div class="page-image">
      <img :src="data.smallurl"/>
    </div>
    <link-item class="page-link"
               v-for="(item,index) in data.links"
               :data='item'
               :id='index'
               :first="data.links.filter(item => item.linktype === 'video')"
               :key="index"></link-item>
  </div>
</template>
<script>
import linkItem from '@/components/linkItem.vue';

export default {
  name: 'page',
  props: {
    data: {
      type: Object,
    },
  },
  mounted() {
    // console.log(this.data.links);
  },
  components: {
    linkItem,
  },
};
</script>
<style lang="less" scoped>
.page{
position: relative;
.page-image{
    img{
        width: 100%;
    }
}}
</style>
